import { Checkbox, Radio } from "@components";
import styles from "@styles/pages/cdp/segmentations.module.scss";

import classNames from "classnames/bind";
import { useState } from "react";
import { Modifiers, ModifierTypes } from "./Modifiers";
import SeeMoreSegmentation from "./SeeMoreSegmentation";
import { GodMode } from "shared/core/GodMode";
const css = classNames.bind(styles);

export const getAskedForLabel = (modifier) => {
  switch (modifier?.name) {
    case ModifierTypes.has_only:
      return "Pediu somente em";
    case ModifierTypes.has_some:
    case ModifierTypes.in_all:
      return "Pediu em";
    case ModifierTypes.has_never:
      return "Nunca pediu em";
    default:
      return "";
  }
};

export const Segments = ({
  categories,
  appliedSegments,
  segments,
  onSelectSegments,
  onConfirmSegments,
  onChangeModifier,
}) => {
  const [openSeeMore, setOpenSeeMore] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const Box = ({ category, option, index, activeModifier }) => {
    const selected = segments?.[category.id]?.options?.some(
      (o) => o.id === option.id
    );
    const applied =
      appliedSegments?.[category.id]?.options?.some(
        (o) => o.id === option.id
      ) && selected;

    const neverOrHasOnly = ["has_never", "has_only"].includes(
      activeModifier?.id
    );

    const askedFor = [
      "unit_id",
      "brand_id",
      "source_id",
      "order_region",
      "order_city",
      "order_state",
    ].includes(category?.id);

    return (
      <div
        className={css({
          box: true,
          selected: selected && !applied,
          applied,
        })}
        key={index}
        onClick={() => onSelectSegments(category, activeModifier, option)}
      >
        <div className="d-flex align-center w-100">
          {!neverOrHasOnly ? (
            <Checkbox value={option.id} checked={selected} readOnly />
          ) : (
            <Radio family="box" value={true} checked={selected} readOnly />
          )}
          <div className={styles.divisor} />
          <div className="d-flex flex-column w-100">
            {askedFor && (
              <p className={styles.askedFor}>
                {getAskedForLabel(activeModifier)}:
              </p>
            )}
            <p className={styles.name} title={option.name}>
              {option.name}
            </p>
          </div>
        </div>

        <span className={styles.quantity}>
          {Number(option?.data?.[activeModifier?.id] || 0).toLocaleString(
            "pt-BR"
          )}
        </span>
      </div>
    );
  };

  const cashbackProgram = localStorage.getItem("cashbackProgram");
  const program = JSON.parse(cashbackProgram);

  const programByPoint = program?.type === "POINT";

  const Segment = ({ category }) => {
    const modifier = category?.modifier || category.modifiers?.[0] || null;

    const sortByQuantity = (array, modifier) => {
      return array.sort((a, b) => {
        const aValue = a?.data?.[modifier]
          ? Number.parseInt(a.data[modifier])
          : 0;
        const bValue = b?.data?.[modifier]
          ? Number.parseInt(b.data[modifier])
          : 0;

        return bValue - aValue;
      });
    };

    const sortedOptions = sortByQuantity(category?.options, modifier.id);

    if (sortedOptions?.length === 0 || !sortedOptions) return;

    const getTitle = () => {
      if (
        [
          "customer_cashback_balance",
          "customer_cashback_credit",
          "customer_cashback_debit",
          "customer_cashback_expiration",
        ].includes(category.id) &&
        programByPoint
      ) {
        return category.name
          .replace(/cashback/g, "pontos")
          .replace(/Cashback/g, "Pontos");
      }

      return category.name;
    };

    return (
      <div className={styles.segment}>
        <div className={styles.header}>
          <div className="d-flex align-center">
            <p className={styles.name}>{getTitle()}</p>
            <span />
            <p className={styles.total}>{sortedOptions?.length || 0}</p>
          </div>

          {modifier && (category.modifiers || [])?.length > 1 && (
            <Modifiers
              modifiers={category.modifiers}
              activeModifier={modifier}
              onChangeModifier={(modifier) =>
                onChangeModifier(category, modifier)
              }
            />
          )}
        </div>

        <div className={styles.boxes}>
          {(sortedOptions || []).slice(0, 12).map((option, index) => (
            <Box
              category={category}
              option={option}
              index={index}
              activeModifier={modifier}
            />
          ))}
          {(sortedOptions || []).length > 12 && (
            <div
              className={styles.showAll}
              onClick={() => {
                setOpenSeeMore(true);
                setSelectedCategory(category);
              }}
            >
              <span>Ver mais {sortedOptions.length - 12}</span>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      {Object.values(categories).map((category) => (
        (GodMode.isGodMode || category.hidden !== true) ? <Segment category={category} key={category?.id} /> : null
      ))}

      {selectedCategory && (
        <SeeMoreSegmentation
          visible={openSeeMore}
          category={selectedCategory}
          segments={segments}
          allSegments={Object.values(categories)}
          onClose={() => setOpenSeeMore(false)}
          onConfirmSegments={(newSegments, category, modifiers) => {
            onChangeModifier(category, modifiers);
            setOpenSeeMore(false);
            onConfirmSegments(newSegments, category, modifiers);
          }}
        />
      )}
    </>
  );
};
